"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewbuildingCard = NewbuildingCard;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _formatters = require("../../utils/formatters");
var _Underground = require("../Underground");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function NewbuildingCard(_ref) {
  let {
    developerLogoUrl,
    imageUrl,
    minPrice,
    name,
    undergroundInfo,
    url,
    developerName,
    address,
    statusDisplay,
    onClick
  } = _ref;
  const displayName = (0, _formatters.formatName)(name);
  const displayMinPrice = (0, _formatters.formatMinPrice)(minPrice);
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer",
    className: styles['container'],
    title: (0, _formatters.formatLinkTitle)({
      name,
      developerName
    }),
    "data-testid": "newbuilding_card",
    onClick: e => onClick(e)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['hovered-block']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['preview']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['img']
  }, /*#__PURE__*/React.createElement(_uiKit.Image, {
    src: imageUrl,
    objectFit: 'cover',
    alt: displayName,
    borderRadius: 0,
    preloader: false
  })), developerLogoUrl && /*#__PURE__*/React.createElement("div", {
    "data-testid": "newbuilding_card_developer_logo",
    className: styles['logo']
  }, /*#__PURE__*/React.createElement(_uiKit.Image, {
    src: developerLogoUrl,
    objectFit: 'cover',
    alt: developerName,
    borderRadius: '4px',
    preloader: false
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, developerName && /*#__PURE__*/React.createElement("div", {
    className: styles['builder']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "gray60_100",
    whiteSpace: "nowrap"
  }, "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A ", developerName)), /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
    as: "h5",
    whiteSpace: "nowrap"
  }, displayName), /*#__PURE__*/React.createElement("div", {
    className: styles['price-group']
  }, displayMinPrice && /*#__PURE__*/React.createElement("div", {
    className: styles['price']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, displayMinPrice)), /*#__PURE__*/React.createElement("div", {
    className: styles['status-display']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, statusDisplay))), undergroundInfo ? /*#__PURE__*/React.createElement(_Underground.Underground, {
    lineColor: undergroundInfo.lineColor,
    name: undergroundInfo.name,
    transportType: undergroundInfo.transportType,
    undergroundType: undergroundInfo.undergroundType,
    timeDisplay: undergroundInfo.timeDisplay
  }) : /*#__PURE__*/React.createElement("div", {
    "data-testid": "newbuilding_card_address",
    className: styles['address']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, address))));
}